import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-attachment-permission';
import { userDate } from 'owa-datetime';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function createLinkModel(
    linkId: string,
    url: string,
    response: GetSharingInfoResponse | null
): SharingLinkInfo {
    if (!response || response.ResultCode !== AttachmentResultCode.Success) {
        return {
            linkId: linkId,
            fileName: null,
            mimeType: null,
            url: url,
            unwrappedUrl: null,
            accessTokenAvailable: false,
            permissionLevel: AttachmentPermissionLevel.None,
            sharingInfo: {
                getSharingInfoSucceeded: false,
                blocksDownload: false,
                canonicalUrl: '',
                canShareInternally: false,
                canShareExternally: false,
                expirationDate: null,
                canRefresh: false,
                shareId: null,
                siteUrl: null,
            },
            supportedPermissionLevels: null,
            sharingUrls: null,
            sharingTipsIgnored: [],
            sharingRecipientsInfo: { recipientPermissionInfos: [] },
            linkActionStatus: LinkActionStatus.none,
        };
    }

    return {
        linkId: linkId,
        fileName: response.FileName,
        mimeType: response.MimeType,
        url: url,
        unwrappedUrl: response.OriginalUrl,
        accessTokenAvailable: true, // We assume the token is available to show the normal UI, and update the property if we cannot get one
        permissionLevel: getAttachmentPermissionLevelFromSharingLinkKind(response.SharingLinkKind),
        sharingInfo: {
            getSharingInfoSucceeded: true,
            blocksDownload: response.BlocksDownload,
            canonicalUrl: response.CanonicalUrl,
            canShareInternally: response.CanShareInternally,
            canShareExternally: response.CanShareExternally,
            expirationDate: response.ExpirationDate ? userDate(response.ExpirationDate) : null,
            canRefresh: response.CanCreateAnonymousEditLink || response.CanCreateAnonymousViewLink,
            shareId: response.ShareId,
            siteUrl: response.SiteUrl,
        },
        supportedPermissionLevels: getSupportedPermissionLevels(response),
        sharingUrls: getSharingUrls(response),
        sharingTipsIgnored: [],
        sharingRecipientsInfo: { recipientPermissionInfos: [] },
        linkActionStatus: LinkActionStatus.none,
    };
}
